import { Text } from '@/shared/ui/primitives';
import type { FC } from 'react';

import { Pill } from '@/shared/ui';
import type { ActionLogDayGroup } from '../model';
import { ActionTimelineItem } from './ActionTimelineItem';
import styles from './ActionTimelineDayGroup.module.css';

interface ActionTimelineDayGroupProps {
  group: ActionLogDayGroup;
}

const formatMoreActions = (count: number): string =>
  `${count} more ${count === 1 ? 'action' : 'actions'}`;

export const ActionTimelineDayGroupView: FC<ActionTimelineDayGroupProps> = ({ group }) => {
  const hiddenCount = group.hiddenCount ?? 0;

  return (
    <section className={styles.group} aria-label={group.dayLabel}>
      <div className={styles.dayLabel}>
        <Pill tone="neutral">{group.dayLabel}</Pill>
      </div>
      <ul className={styles.items}>
        {group.items.map((entry, index) => (
          <ActionTimelineItem
            key={`${entry.timestamp}-${entry.kind}-${'membershipName' in entry ? entry.membershipName : ''}-${index}`}
            entry={entry}
          />
        ))}
        {hiddenCount > 0 && (
          <li className={styles.moreItem}>
            <div className={styles.moreGutter}>
              <span className={styles.moreDot} aria-hidden="true" />
            </div>
            <Text variant="caption" weight="regular" className={styles.moreText}>
              {formatMoreActions(hiddenCount)}
            </Text>
          </li>
        )}
      </ul>
    </section>
  );
};
